var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value !== 'medium')?_c('QIcon',{class:_vm.classes,attrs:{"name":_vm.icon(_vm.name)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }